/*
 * supabase (service)
 */
import { createClient } from "@supabase/supabase-js"

const SUPABASE_URL = process.env.SUPABASE_URL
const SUPABASE_PUBLISHABLE_KEY = process.env.SUPABASE_PUBLISHABLE_KEY

if (!SUPABASE_PUBLISHABLE_KEY) {
	alert("SUPABASE_PUBLISHABLE_KEY is required")
	throw new Error("SUPABASE_PUBLISHABLE_KEY is required")
}
if (!SUPABASE_URL) {
	alert("SUPABASE_URL is required")
	throw new Error("SUPABASE_URL is required")
}

const supabase = createClient(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY)

export default supabase
